<template>

  <tr v-if="isExpanded">
    <td :colspan="headers.length">
      <callsheet-analysis-expand
        :item="item"
        @expand="expandRow"
        :reason="reason"
      ></callsheet-analysis-expand >
    </td>

  </tr>
  <tr v-else>
    <td @click.stop="expandRow">
      {{ itemName }}
    </td>
    <td @click.stop="expandRow">
      {{ itemRole }}
    </td>
    <td @click.stop="expandRow">  
      <reason v-if="makePersonReason"
        :reason="makePersonReason"
        item-type="person"
        compressed
        :clickable="false"
        :forceColor="incomplete ? 'grey' : ''"
        emit="expandrow"
        @expandrow="expandRow"
      ></reason>

    </td>

  </tr>

</template>
<script>
import { getIconColor, getIcon } from '@/js/store'
import Callsheetanalysisexpand from '@/components/Callsheetanalysisexpand'
import { SearchUtils } from '@/js'
import Reason from '@/components/Reason'
export default {
  props: {
    item: Object,
    headers: Array,
    reason: Object,
    expandedRow: Object,
    callsheet: Object
  },
  components: {
    'callsheet-analysis-expand' : Callsheetanalysisexpand,
    reason: Reason
  },
  methods: {
    // this causes the expand screen to come up for a given item
    expandRow () {
      this.$emit('expand', this.isExpanded ? null : this.item)
    }
  },
  
  computed: {
    textSizeClass () {
      return this.$vuetify.breakpoint.smAndUp ? 'caption' : 'fid-xs-small-text'
    },
    isExpanded () {
      return this.expandedRow && this.item.id === this.expandedRow.id
    },
    typeIcon () {
      return getIcon(this.item.type)
    },
    typeIconColor () {
      return getIconColor(this.item.type)
    },
    showIcon () {
      return getIcon(this.isExpanded ? 'hide' : 'show')
    },
    showIconColor () {
      return getIconColor(this.isExpanded ? 'hide' : 'show')
    },
    itemName () {
      return this.item.person
    },
    itemRole () {
      return this.item.profession
    },
    incomplete () {
      return this.makePersonReason && this.makePersonReason.incomplete
    },
    makePersonReason () {
      // the personID in the call sheet analysis row should be in the film to person table
      // except if he has been assigned, but hasnt yet been assigned with a film to person record
      // its not assigned
      if (!this.item.personID) return null

      // its assigned, so see if we have an item - should already be part of the filmtopeople branch
      const filmToPeople = this.reason.Film.FilmToPeople.filter(f=>f.Person && f.Person.id === this.item.personID)
      const base = filmToPeople.length ? filmToPeople : [this.item]
     
      if (base.length) {
        const mats = SearchUtils.makeMatchReasonsFromItem({
          makeType: 'person', 
          makeBase: base,
          item: {
            MatchReasons:[this.item]
          }
        })
       
        if (!mats || !mats[0]) return null
        return {
          ...mats && mats[0],
          incomplete: !filmToPeople.length
        }
      }
      else {
        return null
      }
    }
  }
}
</script>
